import { useMutation } from '@tanstack/react-query';

import {
  getApiHost,
  getMutationFetchOptions,
  MutationHttpError,
  parseMutationHttpResponse,
} from '../utils';
import { MembershipType } from '../../../../src/types/customer';

type MembershipMutationParams = {
  restaurantId: string;
  userId: string;
  planId: string;
  paymentMethodId: string;
};

export const useMembershipMutation = ({
  onSuccess,
  onError,
  onSettled,
}: {
  onSuccess?: (data: MembershipType) => void;
  onError?: (error: MutationHttpError<MembershipMutationError>) => void;
  onSettled?: VoidFunction;
}) =>
  useMutation<
    MembershipType,
    MutationHttpError<MembershipMutationError>,
    MembershipMutationParams
  >({
    mutationFn: async ({ restaurantId, userId, planId, paymentMethodId }) => {
      const apiHost = getApiHost();
      const url = new URL(`/api/customer/${userId}/membership`, apiHost);
      const body = {
        restaurant_id: restaurantId,
        plan_id: planId,
        payment_method_id: paymentMethodId,
      };
      const response = await fetch(url, getMutationFetchOptions('POST', body));
      return parseMutationHttpResponse<MembershipType, MembershipMutationError>(
        response
      );
    },
    onSuccess,
    onError,
    onSettled,
  });

export type MembershipMutationError = {
  code: string;
  message: string;
  reason: string;
};
